import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext } from "react";
import { useHistory } from "react-router";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import {
  setPaso,
  setPasoAnterior,
} from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import TildeOk from "../../../assets/images/generico/TildeOk";
import { ContainerAtencionSinTunroSelect } from "./localStyle";
import { setCentroId } from "_+_Portal/_-_Autocheckin/context/action/atencionSinTurno";
import { getItemWithExpiry } from "../PagesFun";

const AtencionSinTurnoSelect = () => {
  // -------------------------  context ----------------------------
  const { authState } = useContext(GlobalContext);
  const { pasoDispatch, atencionSinTurnoDispatch } =
    useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);

  // -------------------------  context ----------------------------

  // -------------------------  constants ----------------------------
  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState.auth.data.paciente.nombre;
  const history = useHistory();

  // -------------------------  constants ----------------------------

  // -------------------------  functions ----------------------------

  const handleAtencionDia = () => {
    const ubicacionGuardada = getItemWithExpiry("ubicacion");
    if (!ubicacionGuardada) {
      setPasoAnterior("AtencionSinTurnoSelect")(pasoDispatch);
      setPaso("UbicacionSinTurno")(pasoDispatch);
    } else {
      setCentroId([ubicacionGuardada])(atencionSinTurnoDispatch);
      if (ubicacionGuardada.length > 1) {
        setPaso("PreguntarCentro")(pasoDispatch);
      }
      if (ubicacionGuardada && !(ubicacionGuardada.length > 1)) {
        setPaso("AtencioSinTurno")(pasoDispatch);
      }
    }
  };

  const handleInformacionGeneral = () => {
    history.push("/atencionSinTurno");
  };
  // -------------------------  functions ----------------------------

  return (
    <LayoutPasos
      title={"necesito turno"}
      subtitle={"Para: " + camelize(pacienteNombre)}
      handleClick={() => {
        setPaso("NecesitoTurno")(pasoDispatch);
      }}
    >
      <ContainerAtencionSinTunroSelect>
        <span className="title">
          Seleccione según necesite un turno para el día de hoy o si necesita
          información sobre atención sin turno{" "}
        </span>
        <BtnLink
          Icon={
            <TildeOk
              color={"var(--color-primary)"}
              width={"20"}
              height={"20"}
            />
          }
          title={"ATENCIÓN EN EL DÍA"}
          type="NORMAL"
          onclick={handleAtencionDia}
        />
        <BtnLink
          Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
          title={"INFORMACIÓN   GENERAL"}
          type="NORMAL"
          onclick={handleInformacionGeneral}
          spacingWord={true}
        />
      </ContainerAtencionSinTunroSelect>
    </LayoutPasos>
  );
};

export default AtencionSinTurnoSelect;
